

import React, { useState } from 'react';
import { Spin, Pagination } from 'antd';

import ShareIndustryModal from '../shared/ShareIndustryModal';

const followCompany = (props, id, isFollowed, user, companyType) => {
  const { followCompanyType, getCompanyTypeListings } = props;
  followCompanyType(id, isFollowed ? 'unfollow' : 'follow', companyType, user && user.id ? user.id : navigator.userAgent).then(() => {
    getCompanyTypeListings(companyType, user && user.id ? user.id : navigator.userAgent);
  });
};

const CompanyListingsSection = (props) => {
  const { history, pagination, loading, data, user, companyType, shareCompany, setPage, getCompanyTypeListings } = props;
  const { data: companies, total } = data || {};
  const [isShareModalVisible, setShareModalVisibility] = useState(false);
  const [industryId, setIndustryId] = useState(-1);
  
  return (
    <div className='container'>
      <Spin spinning={loading}>
        <div className="mt-4 row">
          {
            companies && companies.length ?
              companies.map(({ company_name, isFollowed, address, cover_image, story, id }, index) => {
                let cover = '/images/school-listing-9.jpg';
                const formattedAddress = address ? (address.length >= 35 ? `${address.substring(0, 30)}...` : address) : 'N/A';
                const formattedStory = story ? (story.length >= 40 ? `${story.substring(0, 40)}...` : story) : 'N/A';
                if (cover_image) {
                  cover = `${process.env.REACT_APP_BACKEND_BASE_URL}${cover_image}`;
                }
                return (
                  <div key={index} className="col-lg-4 col-md-4 col-sm-6 col-12">
                    <div className="school-listing-card">
                      <a href={`${companyType}-details/${id}`}>
                        <div className="img-box">
                          <img style={{ height: '233px', width: '349px' }} src={cover} className="img-fluid" alt="img" />
                        </div>
                        <div className="text">
                          <p className="state">{formattedAddress}</p>
                          <p className="name">{company_name}</p>
                          <p className="desc">{formattedStory}</p>
                        </div>
                      </a>
                      <div className="btn-wrap">
                        <button onClick={() => history.push(`${companyType}-donate/${id}`)} className="btn btn-outline-dark">Donate</button>
                        <div>
                          <button onClick={() => followCompany(props, id, isFollowed, user, companyType)} style={{ border: '0px solid', background: 'none' }}>
                            <svg fill={isFollowed ? 'red' : ''} style={{ marginRight: '10px' }} xmlns="http://www.w3.org/2000/svg" width="16" height="14.234" viewBox="0 0 16 14.234">
                              <path id="heart" d="M14.731,1.393A4.3,4.3,0,0,0,11.531,0,4.025,4.025,0,0,0,9.017.868,5.143,5.143,0,0,0,8,1.929,5.141,5.141,0,0,0,6.984.868,4.024,4.024,0,0,0,4.47,0a4.3,4.3,0,0,0-3.2,1.393A5,5,0,0,0,0,4.808a5.955,5.955,0,0,0,1.587,3.9A33.838,33.838,0,0,0,5.56,12.435c.55.469,1.174,1,1.822,1.567a.939.939,0,0,0,1.237,0c.648-.567,1.272-1.1,1.823-1.568a33.819,33.819,0,0,0,3.972-3.728A5.954,5.954,0,0,0,16,4.808a5,5,0,0,0-1.269-3.415Zm0,0" transform="translate(0)" />
                            </svg>
                            {isFollowed ? 'UnFollow' : 'Follow'}
                          </button>
                          <span
                            onClick={() => {
                              setIndustryId(id);
                              setShareModalVisibility(true);
                            }}>
                            <img
                              style={{ marginRight: 10 }} src="/images/share-icon.png" alt="icon" className="img-fluid"></img>
                            Share
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }) : ''
          }
          {
            companies && companies.length ?
              <div style={{ marginTop: 20 }} className="col-12 text-center">
                <Pagination
                  onChange={(page) => {
                    setPage(page);
                    getCompanyTypeListings(companyType, user && user.id ? user.id : navigator.userAgent);
                  }}
                  size='small'
                  current={pagination.pageNumber}
                  defaultPageSize={pagination.pageSize}
                  pageSizeOptions={[9]}
                  showSizeChange={false}
                  total={total}
                  showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                />
              </div> : ''
          }
        </div>
      </Spin>
      <ShareIndustryModal
        parentPage='listing'
        industryId={industryId}
        companyType={companyType.toLowerCase()}
        user={user}
        shareCompany={shareCompany}
        isShareModalVisible={isShareModalVisible}
        setShareModalVisibility={setShareModalVisibility}
      />
    </div>
  );
}

export default CompanyListingsSection;
